<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>
<ng-template #bodyTemplate>
  <prox-activation-checklist *ngIf="isValidateActivated"
    [activationErrors]="activationService.activateErrors"
    [entityName]="account.name"
    [activationService]="activationService"></prox-activation-checklist>
  <div class="qb-list-actions">
    <p-button (click)="onAagAdd()" size="small" label="Add Administrator Group" icon="pi pi-plus"
      [disabled]="isReadOnly()"></p-button>
    <span class="qb-status-message">{{statusMessage()}}</span>
  </div>
  <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[40, 60]">
    <ng-template pTemplate>
      <div class="flex w-full h-full">
        <div class="w-2/3 h-full py-2">
          <prox-ag-grid [gridOptions]="aagGridOptions"></prox-ag-grid>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex w-full h-full py-2">
        <div class="flex flex-col w-2/3 h-full">
          <div class="qb-child-actions">
            <p-button [disabled]="!selectedAag || isReadOnly()" (click)="onAdminAdd()"
              label="Add Administrators to Administrator Group" icon="pi pi-plus"></p-button>
          </div>
          <div class="grow h-full">
            <prox-ag-grid [gridOptions]="adminGridOptions" [rowData]="admins">
            </prox-ag-grid>
          </div>
        </div>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>
<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()"></prox-save-cancel>
</ng-template>